import React from "react";
import { useRequestContext } from "../../hooks/useRequest";
import { Collapsible } from "../../../components";
import { useHistory } from "react-router-dom";
import { SectionTrigger } from "../../../orderManagement/molecules/SectionTrigger";
import { Button, ButtonGroup } from "../../../components/ui";

export function PublishListing({ step, idx }) {
  const history = useHistory();
  const { getContext, toggleStep } = useRequestContext();
  // Step-aware so a PX group's per-sell-request instance opens ITS trade-in's
  // listing, not one derived from the parent order request.
  const { request } = getContext(idx, step);

  // Sell-only section, so the listing normally lives on the quote — but
  // fall back to a directly-linked listing and guard the deref so a missing
  // quote can't throw on click.
  const listingId =
    request?.last_quote?.listing_id ?? request?.linked_listing_id ?? null;

  const onViewListing = () => {
    if (!listingId) return;
    history.push(`/product/${listingId}`);
  };

  return (
    <Collapsible
      trigger={<SectionTrigger label={step.label} icon="publish" />}
      open={step.open}
      handleTriggerClick={() => toggleStep(idx)}
      testId="confirm-request"
    >
      <ButtonGroup align="end" className="mt-4">
        <Button variant="secondary" data-btn="listing-open" onClick={onViewListing}>
          View listing
        </Button>
      </ButtonGroup>
    </Collapsible>
  );
}
